/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

// TODO: topOffset is not used by nav4. It is only needed by the mobile header system
// which is being removed separately in COREX-13403
export const Container = styled.div<{
  topOffset: number;
  borderLeft?: string;
}>(props => ({
  borderLeft: props.borderLeft,
  display: 'flex',
  height: `calc(100vh - ${props.topOffset}px)`,
  position: 'sticky',
  justifyContent: 'flex-end',
  top: `${props.topOffset}px`,
}));
